export default __webpack_public_path__ + "static/media/statistic.2a0e6b16.png";